import logo from "@/assets/images/logo.svg";

interface LogoProps {
  size: number;
}

export function Logo({ size }: LogoProps) {
  return <img className="invert dark:invert-0" alt="" src={logo} width={size} height={size} />;
}
